exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ruleEngine{width:100%;min-height:calc(100vh - 140px);margin-top:60px;background-color:#f5f5f5}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/rules/rules.component.scss
// module id = 1378
// module chunks = 1